/**
 * GTR (Test Results) system field IDs
 * These correspond to SystemField constants in GWT
 */
export const GTR_SYSTEM_FIELD_IDS = [
  127, // TEST_RESULTS_LABS
  128, // TEST_RESULTS_TESTS_ORDERED
  129, // TEST_RESULTS_TEST_STATUSES
  130, // TEST_RESULTS_RESULTS
  131, // TEST_RESULTS_PATHOGENIC_RESULTS
  132, // TEST_RESULTS_LIKELY_BENIGN_RESULTS
  133, // TEST_RESULTS_LIKELY_PATHOGENIC_RESULTS
  134, // TEST_RESULTS_VUS_RESULTS
  135, // TEST_RESULTS_NEGATIVE_RESULTS
  136, // TEST_RESULTS_GENES_TESTED
  149, // TEST_RESULTS_NOTES
] as const;

/**
 * Check if a field is a GTR (Test Results) system field
 */
export const isGTRSystemField = (fieldId: number | undefined | null): boolean => {
  if (fieldId === undefined || fieldId === null) {
    return false;
  }
  return (GTR_SYSTEM_FIELD_IDS as readonly number[]).includes(fieldId);
};

